import { createFileRoute } from "@tanstack/react-router";
import { Wallet, RefreshCw, Smartphone } from "lucide-react";
import { FeaturePage } from "@/components/marketing/FeaturePage";
import { alternateLinkList } from "@/lib/i18n/locale";
import phoneImg from "@/assets/phone-card.jpg";
import netImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/vi/platform/networking/wallet")({
  head: () => ({
    meta: [
      { title: "Thẻ Apple & Google Wallet — banana.cards" },
      { name: "description", content: "Lưu thẻ kinh doanh số vào Apple Wallet và Google Wallet. Luôn ở một vuốt tay, luôn cập nhật." },
      { property: "og:title", content: "Thẻ Apple & Google Wallet — banana.cards" },
      { property: "og:description", content: "Lưu thẻ vào Wallet, luôn đồng bộ." },
      { property: "og:image", content: phoneImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/networking/wallet", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <FeaturePage
      eyebrow="Thêm vào Wallet"
      title="Thẻ của bạn,"
      italic="trong túi họ."
      description="Người nhận lưu thẻ Banana vào Apple Wallet hoặc Google Wallet trong 1 tap — truy cập tức thì từ lock screen, luôn đồng bộ với hồ sơ mới nhất."
      heroImage={phoneImg}
      metrics={[{ v: "Apple", l: "Wallet" }, { v: "Google", l: "Wallet" }, { v: "Auto", l: "cập nhật" }]}
      bullets={[
        { icon: Wallet, title: "Lưu 1-tap", desc: "Nút 'Add to Wallet' native trên mọi hồ sơ — không cần app, không ma sát." },
        { icon: RefreshCw, title: "Cập nhật live", desc: "Đổi chức danh, số điện thoại hay ảnh — pass đã lưu refresh tự động trên điện thoại họ." },
        { icon: Smartphone, title: "Truy cập lock screen", desc: "Thẻ của bạn hiện từ lock screen khi cần chia sẻ lại." }
      ]}
      deepDives={[
        { eyebrow: "Apple Wallet", title: "Pass native,", italic: "do bạn thiết kế.", description: "Banana sinh pass Apple Wallet đúng chuẩn với branding, ảnh và QR — backed bởi serial ổn định nên cập nhật push tức thì.", image: phoneImg, reverse: false, points: ["Format .pkpass native", "Màu, logo & strip branded", "Auto-update qua push", "QR để re-share tức thì"] },
        { eyebrow: "Google Wallet", title: "Cùng thẻ,", italic: "trên Android.", description: "Pass Google Wallet với cùng dữ liệu và auto-update — mọi người nhận đều covered.", image: netImg, reverse: true, points: ["Pass Google Wallet", "Auto-update khi đổi hồ sơ", "QR universal", "Không cần Play Store"] }
      ]}
      howItWorks={[
        { title: "Chia sẻ thẻ", desc: "Tap, scan hoặc gửi — như thường." },
        { title: "Họ tap 'Add to Wallet'", desc: "Apple hoặc Google, tuỳ máy." },
        { title: "Thẻ vào wallet", desc: "Với ảnh, branding và QR của bạn." },
        { title: "Bạn cập nhật — đồng bộ", desc: "Pass đã lưu refresh tự động." }
      ]}
      capabilities={["Apple Wallet (.pkpass)", "Google Wallet", "Pass tự cập nhật", "Thiết kế branded", "QR trên pass để re-share", "Push notification khi update", "Template pass mỗi thẻ", "Không cần cài app"]}
      faq={[
        { q: "Pass Wallet cho thẻ kinh doanh là gì?", a: "Là thẻ Banana được lưu thành pass native trong wallet — cạnh boarding pass, loyalty card. 1 tap hiện ảnh, tên, chức danh, liên hệ và quick-action." },
        { q: "Người nhận có cần app Banana không?", a: "Không — Wallet pass là native iOS và Android. Cài 1 tap, không signup." },
        { q: "Pass có cập nhật khi đổi chức danh, ảnh?", a: "Có — pass link với hồ sơ live. Sửa 1 lần, mọi pass đã lưu refresh qua Apple/Google push." },
        { q: "Có brand pass với màu, logo công ty không?", a: "Có — đặt màu nền, logo, strip image, màu chữ và accent. Pro plan unlock xoá 'Powered by Banana'." }
      ]}
      outro={{ title: "Luôn ở đó.", italic: "Luôn cập nhật.", description: "Apple & Google Wallet — cách dễ nhất để ai đó giữ thẻ bạn mãi mãi." }}
    />
  );
}